import { render } from "./DataImport.vue?vue&type=template&id=01262bc6&scoped=true"
import script from "./DataImport.vue?vue&type=script&lang=ts"
export * from "./DataImport.vue?vue&type=script&lang=ts"

import "./DataImport.vue?vue&type=style&index=0&id=01262bc6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01262bc6"

export default script